var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFilled = function SvgShareFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.292 10.575v5.675c0 .575-.467 1.042-1.042 1.042H3.75a1.042 1.042 0 0 1-1.042-1.042V3.75c0-.575.467-1.042 1.042-1.042h6.325a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625H3.958v12.084h12.084v-5.467a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625Zm.6-4.725L14.25 2.958a1.041 1.041 0 0 0-1.692.808v.884l-.308.042A5.158 5.158 0 0 0 7.767 9.8c0 .308.2.583.491.683a.7.7 0 0 0 .8-.258 3.937 3.937 0 0 1 3.5-1.575v.892c0 .4.225.758.592.933.15.067.3.108.458.108.234 0 .459-.075.642-.225l3.642-2.891c.25-.2.391-.492.391-.817a1.03 1.03 0 0 0-.391-.817v.017Z",
    fill: "current"
  })));
};
export default SvgShareFilled;